module.exports = __webpack_public_path__ + "img/map.c5f897e6.png";